import { Footer2022, Intro2022 } from './components';
import { use2022Page } from './shared';

const panelJudges = [
  ['EmilChan', 'Prof. Emil Chan', 'Founding Chairman,<br>The Association of Cloud and Mobile Computing Professionals'],
  ['IrEricChan', 'Ir Eric Chan', 'Chief Public Mission Officer,<br>Cyberport'],
  ['DrLawrenceCheung', 'Dr. Lawrence Cheung', 'Chief Innovation Officer,<br>Hong Kong Productivity Council'],
  ['RickyChoi', 'Mr. Ricky Choi', 'Senior Manager,<br>Smart Living, Cyberport'],
  ['DanielChun', 'Mr. Daniel Chun', 'Vice President and Chairman for the Research & Blueprint Committee,<br>Smart City Consortium (SCC)'],
  ['francisfong', 'Mr. Francis Fong', 'Founding and Honorary Chairman,<br>Hong Kong Association of Interactive Marketing'],
  ['SamHui', 'Mr. Sam Hui', 'Chairman,<br>The Chamber of Hong Kong Computer Industry'],
  ['peterkoo', 'Mr. Peter Koo', 'Director of Finance Committee,<br>GBA 5G Industry Alliance'],
  ['sandraleung', 'Ms. Sandra Leung', 'Founder and Executive Director,<br>Hong Kong Technology Advancement Group'],
  ['vincentso', 'Mr. Vincent So', 'Chairman,<br>Hong Kong Retail Technology Industry Association'],
  ['yvonnewong', 'Ms. Yvonne Wong', 'Chairman,<br>Hong Kong United Youth Science and Technology Association'],
] as const;

const Judges2022 = () => {
  use2022Page({ cate: 'judges', lang: 'en', title: 'Smart Living Partnership Awards 2022 - Judges' });
  return (
    <div className="slpa2022-root">
      <Intro2022 lang="en" />
      <section id="LeadIn"><div className="wave_bg"><img src="/2022/images/judgebg-01.png" alt="" /></div></section>
      <section id="Judges">
        <div className="Judges_info">
          <div className="Judges_Title">JUDGES</div>
          <div className="Judges_TitleLine"><div className="Judges_TitleLineDot"><img src="/2022/images/linedot.png" alt="" /></div></div>
          <div className="Judges_HeadofJudge">
            <div className="Judges_HeadofJudge_Image"><img src="/2022/images/judgebubble-bg.png" alt="" /></div>
            <div className="Judges_HeadofJudge_info">
              <div className="Judges_HeadofJudge_Title">Head of Judge</div>
              <div className="Judges_HeadofJudge_Name">Dr. Winnie Tang, MH, JP</div>
              <div className="Judges_HeadofJudge_Reputation">Founder and Honorary President,<br />Smart City Consortium</div>
              <div className="Judges_HeadofJudge_Details">Dr. Winnie Tang, MH, JP, is an Honorary Professor in the Department of Computer Science at the University of Hong Kong. She is one of the locally-bred IT entrepreneurs of Hong Kong. In the 1990s, Dr. Tang founded Esri China (Hong Kong) Limited to develop and promote Geographic Information System (GIS) software and solutions. Over the years, Dr. Tang has been actively advocating the use of technology through her services in government and non-government organizations in Hong Kong.</div>
            </div>
          </div>
          <div className="Judges_PanelofJudge">
            <div className="Judges_Title">Panel of Judges</div>
            <div className="Judges_PanelofJudge_Table">
              {panelJudges.map(([img, name, rep]) => (
                <div className="Judges_PanelofJudge_Judge" key={name}>
                  <div className="Judges_PanelofJudge_Image">
                    <div className="Judges_PanelofJudge_Image_bg"><img src="/2022/images/judgebubble-bg.png" alt="" /></div>
                    <div className="Judges_PanelofJudge_Image_judge"><img src={`/2022/images/${img}.png`} alt="" className="clip-circle" /></div>
                  </div>
                  <div className="Judges_PanelofJudge_Info">
                    <div className="Judges_PanelofJudge_Name">{name}</div>
                    <div className="Judges_PanelofJudge_Reputation" dangerouslySetInnerHTML={{ __html: rep }} />
                  </div>
                </div>
              ))}
            </div>
            <div className="Judges_Title">Legal Advisor</div>
            <div className="Judges_PanelofJudge_Table">
              <div className="Judges_PanelofJudge_Judge">
                <div className="Judges_PanelofJudge_Image">
                  <div className="Judges_PanelofJudge_Image_bg"><img src="/2022/images/judgebubble-bg.png" alt="" /></div>
                  <div className="Judges_PanelofJudge_Image_judge"><img src="/2022/images/valenttse.png" alt="" className="clip-circle" /></div>
                </div>
                <div className="Judges_PanelofJudge_Info">
                  <div className="Judges_PanelofJudge_Name">Mr. Valent Tse</div>
                  <div className="Judges_PanelofJudge_Reputation">Partner,<br />Messrs. Tung, Ng, Tse & Lam, Solicitors ("TNTL")</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer2022 lang="en" />
    </div>
  );
};

export default Judges2022;

